const AustraliaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110794)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0047 20 0.00226562 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9817 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91562 20 4.60961 20 0H19.9966C8.9525 0.00179688 0 8.95531 0 19.9999H10.4348V14.124L16.3107 19.9999H19.9466C19.9645 19.9821 19.9823 19.9643 20.0001 19.9464C20.0001 18.599 20.0001 17.3967 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38957 6.99004 2.6084 10.1181V19.9997H7.82582V7.8259V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9992 17.5402L12.8935 10.4346H10.4341C10.4341 10.4345 10.4341 10.4346 10.4341 10.4346L19.9992 19.9997H19.9992C19.9992 19.9997 19.9992 18.304 19.9992 17.5402Z"
        fill="#D80027"
      />
      <path
        d="M12.0617 23.4785L13.1593 25.7737L15.638 25.2008L14.528 27.49L16.5213 29.0707L14.0395 29.6301L14.0464 32.1741L12.0617 30.5825L10.077 32.1741L10.0839 29.6301L7.60205 29.0707L9.59541 27.49L8.48525 25.2008L10.9641 25.7737L12.0617 23.4785Z"
        fill="#F0F0F0"
      />
      <path
        d="M29.9436 27.8271L30.4925 28.9747L31.7318 28.6882L31.1768 29.8328L32.1735 30.6232L30.9325 30.9029L30.936 32.175L29.9436 31.3791L28.9513 32.175L28.9547 30.9029L27.7139 30.6232L28.7105 29.8328L28.1555 28.6882L29.3948 28.9747L29.9436 27.8271Z"
        fill="#F0F0F0"
      />
      <path
        d="M24.8382 15.6514L25.387 16.799L26.6264 16.5125L26.0714 17.6571L27.068 18.4475L25.8271 18.7271L25.8305 19.9992L24.8382 19.2033L23.8459 19.9992L23.8493 18.7271L22.6084 18.4475L23.605 17.6571L23.05 16.5125L24.2894 16.799L24.8382 15.6514Z"
        fill="#F0F0F0"
      />
      <path
        d="M29.9436 8.69531L30.4925 9.84297L31.7318 9.55648L31.1768 10.7011L32.1734 11.4914L30.9325 11.7712L30.936 13.0432L29.9436 12.2473L28.9513 13.0432L28.9547 11.7712L27.7139 11.4914L28.7104 10.7011L28.1555 9.55648L29.3948 9.84297L29.9436 8.69531Z"
        fill="#F0F0F0"
      />
      <path
        d="M34.4032 13.9131L34.9519 15.0607L36.1913 14.7742L35.6363 15.9188L36.6329 16.7092L35.392 16.9889L35.3955 18.2609L34.4032 17.4651L33.4108 18.2609L33.4142 16.9889L32.1733 16.7092L33.17 15.9188L32.615 14.7742L33.8543 15.0607L34.4032 13.9131Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.2144 20L31.6461 21.3286H33.0431L31.9129 22.1498L32.3446 23.4783L31.2144 22.6572L30.0843 23.4783L30.5159 22.1498L29.3857 21.3286H30.7827L31.2144 20Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110794">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AustraliaSvg;
